import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import salesTaxTotal from './salesTaxTotal.selector';
import registrationTotal from './registrationTotal.selector';
import titleTotal from './titleTotal.selector';
import otherTransactionFeesTotal from './otherTransactionFeesTotal.selector';

const salesTaxTotalSel = state => salesTaxTotal(state);
const titleTotalSel = state => titleTotal(state);
const registrationTotalSel = state => registrationTotal(state);
const otherTransactionFeesSel = state => otherTransactionFeesTotal(state);

const selector = createSelector(
  [salesTaxTotalSel, titleTotalSel, registrationTotalSel, otherTransactionFeesSel],
  (sales, title, registration, other) => {
    return precise(Number(sales) + Number(title) + Number(registration) + Number(other));
  },
);

export default selector;
